module.exports = __webpack_public_path__ + "img/product-8.148cd9cc.jpg";